<template>
  <div>
    <b-button variant="primary" :disabled="disabled" class="d-flex buttonHeight position-relative" @click="addToCart">
      <font-awesome-icon icon="cart-plus" class="mt-1"></font-awesome-icon>
      <transition name="fade">
        <div class="white-icon ml-2 check-position" v-if="added">
          <p class="white-iconfix">
            <font-awesome-icon icon="check-circle" class="green vertical-align-middle"></font-awesome-icon>
          </p>
        </div>
      </transition>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'cart-button',
  data: function () {
    return {
      added: false,
      clearTimeout: null
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    addToCart: function () {
      this.$store.commit('addOrder', {
        id: this.product.id,
        image: this.product.image,
        name: this.product.name,
        amount: this.amount,
        price: this.product.price,
        reducedPrice: this.product.reduced_price,
        orderedBefore: this.product.ordered_before,
        stock: this.product.stock,
        preorder: this.product.preorder,
        backorder: this.product.backorder
      })
      window.fbq('track', 'AddToCart', {
        value: this.product.price,
        currency: 'EUR',
        contents: [
          {
            id: this.product.id,
            quantity: this.amount,
            name: this.product.name
          }
        ],
        content_type: 'product',
        product_catalog_id: this.product.id
      })
      this.added = true
    }
  },
  watch: {
    added: function () {
      let self = this
      clearTimeout(this.clearTimeout)
      let time = 2000
      this.clearTimeout = setTimeout(function () {
        self.added = false
      }, time)
    }
  }
}
</script>

<style scoped>
  .buttonHeight {
    height: 36px;
  }

  .check-position {
    position: absolute !important;
    top: 11px !important;
    left: 8px !important;
  }

  .white-icon {
    background: #fff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: relative;
    top: 4px;
  }

  .white-iconfix {
    position: relative;
    top: -6px;
    left: -2px;
  }

  .vertical-align-middle {
    vertical-align: middle;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CartButton.vue